import { routersTypes } from 'src/pages/routes';
/*
 * @authors :Bin Mei
 * @description：  患者管理模块路由
 */
const route: routersTypes[] = [
  {
    path: '/hospital/intro',
    name: 'StaticIntro',
    component: () => import(/* webpackPrefetchPlaceHolder */ './intro'),
    auth: false,
    exact: true,
    title: '众安互联网医院',
  },
  {
    path: '/hospital/free',
    name: 'StaticFree',
    component: () => import(/* webpackPrefetchPlaceHolder */ './intro/free'),
    auth: false,
    exact: true,
    title: '众安互联网医院',
  },
  {
    path: '/hospital/agreement',
    name: 'StaticAgreement',
    component: () => import(/* webpackPrefetchPlaceHolder */ './agreement'),
    auth: false,
    exact: true,
    title: '用户协议',
  },
  {
    path: '/hospital/private',
    name: 'StaticPrivate',
    component: () => import(/* webpackPrefetchPlaceHolder */ './private'),
    auth: false,
    exact: true,
    title: '隐私政策',
  },
  {
    path: '/hospital/qualifications',
    name: 'StaticQualifications',
    component: () => import(/* webpackPrefetchPlaceHolder */ './qualifications'),
    auth: false,
    exact: true,
    title: '平台资质',
  },
  {
    path: '/hospital/static/rights/:vasCode',
    name: 'StaticQualifications',
    component: () => import(/* webpackPrefetchPlaceHolder */ './rights'),
    auth: false,
    exact: true,
    title: '权益详情',
  },
  {
    path: '/hospital/servpack',
    name: 'StaticServpack',
    component: () => import(/* webpackPrefetchPlaceHolder */ './servpack'),
    auth: false,
    exact: true,
    title: '众安保险用户专属福利',
  },
  {
    path: '/hospital/static/glu',
    name: 'StaticGlu',
    component: () => import(/* webpackPrefetchPlaceHolder */ './glu'),
    auth: false,
    exact: true,
    title: '互联网医院专属福利',
  },
  {
    path: '/hospital/static/zuifuli',
    name: 'StaticZuifuli',
    component: () => import(/* webpackPrefetchPlaceHolder */ './zuifuli'),
    auth: false,
    exact: true,
    title: '众安员工团险专享',
  },
  {
    path: '/hospital/static/checkup',
    name: 'StaticCheckUp',
    component: () => import(/* webpackPrefetchPlaceHolder */ './checkup'),
    auth: false,
    exact: true,
    title: '众安保险',
  },
  {
    path: '/hospital/static/checkup/offer',
    name: 'StaticOffer',
    component: () => import(/* webpackPrefetchPlaceHolder */ './checkup/offer'),
    auth: false,
    exact: true,
    title: '众安保险',
  },
  {
    path: '/hospital/static/bulter',
    name: 'introBulter',
    component: () => import(/* webpackPrefetchPlaceHolder */ './intro/bulter'),
    auth: false,
    exact: true,
    title: '医管家介绍',
  },
  {
    path: '/hospital/static/wanyuanbao',
    name: 'StaticZuifuli',
    component: () => import(/* webpackPrefetchPlaceHolder */ './servpack/wanyuanbao'),
    auth: false,
    exact: true,
    title: '众安保险用户专属福利',
  },
  {
    path: '/hospital/static/zaapp/doubleeleven',
    name: 'StaticZaAPP',
    component: () => import(/* webpackPrefetchPlaceHolder */ './zaapp/doubleeleven'),
    auth: false,
    exact: true,
    title: '众安保险用户专属福利',
  },
  {
    path: '/hospital/static/zaapp/offer',
    name: 'StaticZaAPP',
    component: () => import(/* webpackPrefetchPlaceHolder */ './zaapp/offer'),
    auth: false,
    exact: true,
    title: '众安保险用户专属福利',
  },
  {
    path: '/hospital/static/vaccine',
    name: 'StaticVaccine',
    component: () => import(/* webpackPrefetchPlaceHolder */ './vaccine'),
    auth: true,
    exact: true,
    title: '医管家疫苗服务',
  },
  {
    path: '/hospital/static/nvshenjie',
    name: 'StaticNvshen',
    component: () => import(/* webpackPrefetchPlaceHolder */ './nvshenjie/index'),
    auth: false,
    exact: true,
    title: '女神爱美丽',
  },
  {
    path: '/hospital/static/nvshenjie/success',
    name: 'StaticNvshenSuccess',
    component: () => import(/* webpackPrefetchPlaceHolder */ './nvshenjie/success'),
    auth: false,
    exact: true,
    title: '订单支付成功',
  },
  {
    path: '/hospital/static/shunfeng',
    name: 'StaticShunfeng',
    component: () => import(/* webpackPrefetchPlaceHolder */ './shunfeng'),
    auth: true,
    exact: true,
    title: '领取图文问诊权益',
  },
  {
    path: '/hospital/static/comarketing',
    name: 'StaticCoMarketing',
    component: () => import(/* webpackPrefetchPlaceHolder */ './coMarketing'),
    auth: true,
    exact: true,
    title: '众安互联网医院',
  },
  {
    path: '/hospital/static/activity-expire',
    name: 'StaticActivityExpire',
    component: () => import(/* webpackPrefetchPlaceHolder */ './activityExpire'),
    auth: false,
    exact: true,
    title: '众安互联网医院',
  },
  {
    path: '/hospital/static/no-rights',
    name: 'StaticNoRights',
    component: () => import(/* webpackPrefetchPlaceHolder */ './noRights'),
    auth: false,
    exact: true,
    title: '众安互联网医院',
  },
  {
    path: '/hospital/static/xiaodai/offer',
    name: 'StaticXiaodaiOffer',
    component: () => import(/* webpackPrefetchPlaceHolder */ './xiaodai/offer'),
    auth: false,
    exact: true,
    title: '众安保险用户专属福利',
  },
  {
    path: '/hospital/static/notice/riskinforming/agreement',
    name: 'StaticNoticeAgreement',
    component: () => import(/* webpackPrefetchPlaceHolder */ './noticeAgreement'),
    auth: false,
    exact: true,
    title: '互联网诊疗风险告知及知情同意书',
  },
  {
    path: '/hospital/static/yunyaofang',
    name: 'StaticYunyaofang',
    component: () => import(/* webpackPrefetchPlaceHolder */ './yunyaofang'),
    auth: false,
    exact: true,
    title: '众安大药房',
  },
  {
    path: '/hospital/static/oneservpack',
    name: 'OneServPack',
    component: () => import(/* webpackPrefetchPlaceHolder */ './oneServPack'),
    auth: true,
    exact: true,
    title: '众安互联网医院',
  },
  {
    path: '/hospital/static/oneservpack/buy',
    name: 'OneServPackBuy',
    component: () => import(/* webpackPrefetchPlaceHolder */ './oneServPack/buy'),
    auth: true,
    exact: true,
    title: '众安互联网医院',
  },
  {
    path: '/hospital/static/oneservpack/paysuccess',
    name: 'OneServPackPaySuccess',
    component: () => import(/* webpackPrefetchPlaceHolder */ './oneServPack/paySuccess'),
    auth: true,
    exact: true,
    title: '众安互联网医院',
  },
  {
    path: '/hospital/static/ylservpack',
    name: 'YinLianServPack',
    component: () => import(/* webpackPrefetchPlaceHolder */ './ylServPack'),
    auth: true,
    exact: true,
    title: '众安互联网医院',
  },
  {
    path: '/hospital/static/bybodental',
    name: 'ByboDental',
    component: () => import('./bybodental'),
    auth: true,
    exact: true,
    title: '数字化口腔检查',
  },
  {
    path: '/hospital/static/declinatureRedevelopment',
    name: 'DeclinatureRedevelopment',
    component: () => import('./declinatureRedevelopment'),
    auth: false,
    exact: true,
    title: '免费领取健康服务卡',
  },
  {
    path: '/hospital/static/ypmallActivity',
    name: 'YpmallActivity',
    component: () => import('./ypmallActivity'),
    auth: true,
    exact: true,
    title: '健康好物2.9元起',
  },
  {
    path: '/hospital/static/hospitalsearch',
    name: 'HospitalSearch',
    component: () => import('./hospital'),
    auth: false,
    exact: true,
    title: '理赔医院查询',
  },
  {
    path: '/hospital/static/hospitalrank',
    name: 'HospitalRank',
    component: () => import('./hospital/rank'),
    auth: true,
    exact: true,
    title: '理赔医院查询',
  },
  {
    path: '/hospital/static/winteract',
    name: 'winterAct',
    component: () => import('./winterAct'),
    auth: false,
    exact: true,
    title: '众安互联网医院',
  },
  {
    path: '/hospital/static/sfhome',
    name: 'SFHome',
    component: () => import('./sfhome'),
    auth: true,
    exact: true,
    title: '顺丰医管家',
  },
  {
    path: '/hospital/static/hpdetection',
    name: 'hpdetection',
    component: () => import('./hpdetection'),
    auth: false,
    exact: true,
    title: '众安无“幽”健康服务',
  },
  {
    path: '/hospital/static/hpdetection/buy',
    name: 'hpdetecitonBuy',
    component: () => import('./hpdetection/buy'),
    auth: false,
    exact: true,
    title: '众安互联网医院',
  },
  {
    path: '/hospital/static/favouredservpack',
    name: 'favouredservpack',
    component: () => import('./favouredServPack'),
    auth: false,
    exact: true,
    title: '家庭医生-普惠版',
  },
  {
    path: '/hospital/static/channelServPack',
    name: 'channelServPack',
    component: () => import('./channelServPack'),
    auth: false,
    exact: true,
    title: '家庭医生-普惠版',
  },
  {
    path: '/hospital/static/hpvservpack',
    name: 'hpvServPack',
    component: () => import('./hpvServPack'),
    auth: false,
    exact: true,
    title: '众安宫无忧健康管理服务',
  },
  {
    path: '/hospital/static/hpvServPack/buy',
    name: 'hpvServPackBuy',
    component: () => import('./hpvServPack/buy'),
    auth: false,
    exact: true,
    title: '众安互联网医院',
  },
  {
    path: '/hospital/static/hpdetection/paySuccess',
    name: 'hpdetecitonBug',
    component: () => import('./hpdetection/paySuccess'),
    auth: false,
    exact: true,
    title: '众安互联网医院',
  },
  {
    path: '/hospital/static/commonSuccess/:secondBtnType',
    name: 'commonSuccess',
    component: () => import('./hpdetection/paySuccess'),
    auth: true,
    exact: true,
    title: '众安互联网医院',
  },
  {
    path: '/hospital/static/colorectalcancer',
    name: 'colorectalCancer',
    component: () => import('./colorectalCancer'),
    auth: true,
    exact: true,
    title: '众安互联网医院',
  },
  {
    path: '/hospital/static/commonbuy',
    name: 'commonBuy',
    component: () => import('./commonBuy'),
    auth: true,
    exact: true,
    title: '众安互联网医院',
  },
  {
    path: '/hospital/static/cloudmedicalbox',
    name: 'cloudMedicalBox',
    component: () => import('./cloudMedicalBox'),
    auth: true,
    exact: true,
    title: '众安互联网医院',
  },
  {
    path: '/hospital/static/commonServPack',
    name: 'commonServPack',
    component: () => import('./commonServPack'),
    auth: false,
    exact: true,
    title: '众安互联网医院',
  },
  {
    path: '/hospital/static/cleanteeth',
    name: 'cleanTeeth',
    component: () => import('./cleanTeeth'),
    auth: false,
    exact: true,
    title: '众安互联网医院',
  },
  {
    path: '/hospital/static/selectcity',
    name: 'cleanTeeth',
    component: () => import('./cleanTeeth/selectCity'),
    auth: true,
    exact: true,
    title: '众安互联网医院',
  },
  {
    path: '/hospital/static/hptest',
    name: 'hpTest',
    component: () => import('./hpTest'),
    auth: true,
    exact: true,
    title: 'HP自测',
  },
  {
    path: '/hospital/static/seasonalmedbox',
    name: 'Seasonalmedbox',
    component: () => import('./Seasonalmedbox'),
    auth: true,
    exact: true,
    title: '应季小药箱',
  },
  {
    path: '/hospital/static/smallMedicineBox',
    name: 'Seasonalmedbox',
    component: () => import('./SmallMedicineBox'),
    auth: true,
    exact: true,
    title: '小药箱',
  },
  {
    path: '/hospital/static/changweiqing',
    name: 'hpTest',
    component: () => import('./changweiqing'),
    auth: true,
    exact: true,
    title: '常卫清',
  },
  {
    path: '/hospital/static/shanzhen',
    name: 'hpTest',
    component: () => import('./shanzhen'),
    auth: true,
    exact: true,
    title: '防癌早筛',
  },
  {
    path: '/hospital/static/hpvappoint',
    name: 'hpvappoint',
    component: () => import('./hpvAppoint'),
    auth: true,
    exact: true,
    title: '疫苗预约',
  },
  {
    path: '/hospital/static/fattyLiver',
    name: 'fattyLiver',
    component: () => import('./fattyLiver'),
    auth: true,
    exact: true,
    title: '脂肪肝安心保',
  },
  {
    path: '/hospital/static/fattyLiver/auth',
    name: 'fattyLiverAuth',
    component: () => import('./fattyLiver/auth'),
    auth: true,
    exact: true,
    title: '脂肪肝安心保',
  },
  {
    path: '/hospital/static/freeservpack',
    name: 'freeServPack',
    component: () => import('./freeServpack'),
    auth: true,
    exact: true,
    title: '尊享权益-购药三折',
  },
  {
    path: '/hospital/static/wuyou',
    name: 'wuyou',
    component: () => import('./wuyou'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '健康管理服务',
  },
  {
    path: '/hospital/static/childrenhealth',
    name: 'childrenhealth',
    component: () => import('./wuyou/childrenhealth'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '儿童健管服务',
  },
  {
    path: '/hospital/static/healthService/:vasCode',
    name: 'healthService',
    component: () => import('./healthService'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '健康服务',
  },
  {
    path: '/hospital/static/zhenxiang',
    name: 'zhenxiang',
    component: () => import('./zhenxiang'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '健康服务五选一',
  },
  {
    path: '/hospital/static/zhenxiang/plus',
    name: 'zhenxiangPlus',
    component: () => import('./zhenxiang/plus'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '健康服务五选一',
  },
  {
    path: '/hospital/static/zunxiang',
    name: 'zhenxiangPlus',
    component: () => import('./zhenxiang/ZXHealthService'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '健康服务四选一',
  },
  {
    path: '/hospital/static/zunxiang/plus',
    name: 'zhenxiangPlus',
    component: () => import('./zhenxiang/ZXHealthServicePlus'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '健康服务四选一',
  },
  {
    path: '/hospital/static/zhenxiangservice26',
    name: 'zhenxiangService26',
    component: () => import('./zhenxiang/ZhenxiangService26'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '臻享管理服务26',
  },
  {
    path: '/hospital/static/premiumhealthplus26',
    name: 'premiumHealthplus26',
    component: () => import('./zhenxiang/PremiumHealthplus26'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '臻享管理服务Plus26',
  },
  {
    path: '/hospital/static/etjk',
    name: 'etjk',
    component: () => import('./zhenxiang/etjk'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '儿童健康服务',
  },
  {
    path: '/hospital/static/etjkfw',
    name: 'etjk',
    component: () => import('./zhenxiang/etjkfw'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '儿童健康服务',
  },
  {
    path: '/hospital/static/yyys',
    name: 'etjk',
    component: () => import('./zhenxiang/yyys'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '营养元素代谢基因检测',
  },
  {
    path: '/hospital/static/yyywy',
    name: 'etjk',
    component: () => import('./zhenxiang/yyywy'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '药无忧自选服务包',
  },
  {
    path: '/hospital/static/yyywylist',
    name: 'etjk',
    component: () => import('./zhenxiang/yyywylist'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '药无忧自选服务包',
  },
  {
    path: '/hospital/static/kfll',
    name: 'etjk',
    component: () => import('./zhenxiang/kfll'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '康复理疗',
  },
  {
    path: '/hospital/static/kfll26plus',
    name: 'kfll26plus',
    component: () => import('./zhenxiang/kfll26plus'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '康复理疗',
  },
  {
    path: '/hospital/static/nsjc',
    name: 'etjk',
    component: () => import('./zhenxiang/nsjc'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '食物不耐受检测',
  },
  {
    path: '/hospital/static/serviceDetail/:service',
    name: 'etjk',
    component: () => import('./zhenxiang/ServiceDetail'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '详情',
  },
  {
    path: '/hospital/static/etjkservice',
    name: 'etjkservice',
    component: () => import('./zhenxiang/etjkservice'),
    auth: true,
    exact: true,
    title: '儿童健康服务',
  },
  {
    path: '/hospital/static/zhenxiangsuccess',
    name: 'zhenxiangsuccess',
    component: () => import('./zhenxiang/success'),
    auth: true,
    exact: true,
    title: '申请成功',
  },
  {
    path: '/hospital/static/zhenxiangykdetail',
    name: 'zhenxiangykdetail',
    component: () => import('./zhenxiang/ykdetail'),
    auth: true,
    exact: true,
    title: '申请记录',
  },
  {
    path: '/hospital/static/jktj',
    name: 'jktj',
    component: () => import('./zhenxiang/jktj'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '健康体检',
  },{
    path: '/hospital/static/sgmb',
    name: 'sgmb',
    component: () => import('./zhenxiang/sgmb'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '慢病管理服务',
  },{
    path: '/hospital/static/sgmbPlus',
    name: 'sgmb',
    component: () => import('./zhenxiang/sgmbPlus'),
    auth: true,
    exact: true,
    title: '慢病管理服务',
  },{
    path: '/hospital/static/sjxyx',
    name: 'sjxyx',
    component: () => import('./zhenxiang/sjxyx'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '四季小药箱',
  },
  {
    path: '/hospital/static/sjxyxservice',
    name: 'sjxyxservice',
    component: () => import('./zhenxiang/sjxyxservice'),
    auth: true,
    exact: true,
    title: '四季小药箱',
  },
  {
    path: '/hospital/static/sjxyxaddress',
    name: 'sjxyxaddress',
    component: () => import('./zhenxiang/sjxyxaddress'),
    auth: true,
    exact: true,
    title: '四季小药箱',
  },
  {
    path: '/hospital/static/wcd',
    name: 'wcd',
    component: () => import('./zhenxiang/wcd'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '胃肠道健康服务',
  },{
    path: '/hospital/static/wcdservice',
    name: 'wcdservice',
    component: () => import('./zhenxiang/wcdservice'),
    auth: true,
    exact: true,
    title: '胃肠道健康服务',
  },
  {
    path: '/hospital/static/jinxuan',
    name: 'jinxuan',
    component: () => import('./jinxuan'),
    auth: true,
    exact: true,
    title: '金选健康四选一',
  },
  {
    path: '/hospital/static/jinxuanStudy',
    name: 'jinxuanStudy',
    component: () => import('./jinxuanStudy'),
    auth: true,
    exact: true,
    title: '金选畅学',
  },
  {
    path: '/hospital/static/SeriousIllnessGreenChannel',
    name: 'SeriousIllnessGreenChannel',
    component: () => import('./SeriousIllnessGreenChannel'),
    auth: true,
    exact: true,
    title: '重疾直通车',
  },
  {
    path: '/hospital/static/Eenjoyhealth',
    name: 'Eenjoyhealth',
    component: () => import('./Eenjoyhealth'),
    auth: true,
    exact: true,
    title: 'e享安康服务',
  },
  {
    path: '/hospital/static/CriticalConditionsTel',
    name: 'CriticalConditionsTel',
    component: () => import('./CriticalConditionsTel'),
    auth: true,
    exact: true,
    title: '重疾名医视频联诊',
  },
  {
    path: '/hospital/static/initialReducingFat',
    name: 'InitialReducingFat',
    component: () => import(/* webpackPrefetchPlaceHolder */ './initialReducingFat'),
    auth: false,
    exact: true,
    title: '我的权益',
  },
  {
    path: '/hospital/static/payforhealthservice',
    name: 'InitialReducingFat',
    component: () => import(/* webpackPrefetchPlaceHolder */ './payforhealthservice'),
    auth: false,
    exact: true,
    title: '我的权益',
  },
  {
    path: '/hospital/static/ruyuAnkang',
    name: 'ruyurehabilitation',
    component: () => import(/* webpackPrefetchPlaceHolder */ './ruyuAnkang'),
    auth: false,
    exact: true,
    title: '乳愈安康营养包',
  },
  {
    path: '/hospital/static/oppointmentDoctor',
    name: 'oppointmentDoctor',
    component: () => import(/* webpackPrefetchPlaceHolder */ './oppointmentDoctor'),
    auth: false,
    exact: true,
    title: '专科挂号服务',
  },
  {
    path: '/hospital/static/jwyHealthservice',
    name: 'jwyHealthservice',
    component: () => import(/* webpackPrefetchPlaceHolder */ './jwyHealthservice'),
    auth: false,
    exact: true,
    title: '甲无忧健康管理',
  },
  {
    path: '/hospital/static/healthRights',
    name: 'adancedHeath',
    component: () => import(/* webpackPrefetchPlaceHolder */ './healthRights'),
    auth: false,
    exact: true,
    title: '健康权益',
  },
  {
    path: '/hospital/static/healthRights/detail/:id',
    name: 'adancedHeath',
    component: () => import(/* webpackPrefetchPlaceHolder */ './healthRights/healthDetail'),
    auth: false,
    exact: true,
    title: '健康权益',
  },
  {
    path: '/hospital/static/physicalGoodsService/:vasCode',
    name: 'physicalGoodsServive',
    component: () => import(/* webpackPrefetchPlaceHolder */ './physicalGoodsService'),
    auth: false,
    exact: true,
    title: '健康权益',
  },
  {
    path: '/hospital/static/zhenxiang/goodsService/:subOrderType',
    name: 'physicalGoodsServive',
    component: () => import(/* webpackPrefetchPlaceHolder */ './zhenxiang/goodsService'),
    auth: false,
    exact: true,
    title: '健康权益',
  },
  {
    path: '/hospital/static/mntjService',
    name: 'mntjService',
    component: () => import(/* webpackPrefetchPlaceHolder */ './mntjService'),
    auth: false,
    exact: true,
    title: '健康权益',
  },
  {
    path: '/hospital/static/healthCheckService/:vasCode',
    name: 'healthCheckService',
    component: () => import(/* webpackPrefetchPlaceHolder */ './healthCheckService'),
    auth: false,
    exact: true,
    title: '健康权益',
  },
  {
    path: '/hospital/static/tertiaryInquiry',
    name: 'tertiaryInquiry',
    component: () => import(/* webpackPrefetchPlaceHolder */ './tertiaryInquiry'),
    auth: false,
    exact: true,
    title: '三甲医生问诊',
  },
  {
    path: '/hospital/static/outhpmedication',
    name: 'Outhpmedication',
    component: () => import(/* webpackPrefetchPlaceHolder */ './Outhpmedication'),
    auth: false,
    exact: true,
    title: 'e享外购药服务',
  },
  {
    path: '/hospital/static/serviceWakeFlow',
    name: 'ServiceWakeFlow',
    component: () => import(/* webpackPrefetchPlaceHolder */ './serviceWakeFlow'),
    auth: false,
    exact: true,
    title: '服务申请成功',
  },
  {
    path: '/hospital/static/guideOperation',
    name: 'GuideOperation',
    component: () => import(/* webpackPrefetchPlaceHolder */ './guideOperation'),
    auth: false,
    exact: true,
    title: '众安互联网医院',
  },
  {
    path: '/hospital/static/guideOperationCode',
    name: 'GuideOperation',
    component: () => import(/* webpackPrefetchPlaceHolder */ './guideOperationCode'),
    auth: false,
    exact: true,
    title: '众安互联网医院',
  },
  {
    path: '/hospital/static/serviceOutlets/:vasCode',
    name: 'ServiceOutlets',
    component: () => import(/* webpackPrefetchPlaceHolder */ './serviceOutlets'),
    auth: false,
    exact: true,
    title: '服务网点',
  },
  {
    path: '/hospital/static/nursingservice/:vasCode',
    name: 'NursingService',
    component: () => import(/* webpackPrefetchPlaceHolder */ './nursingservice'),
    auth: true,
    exact: true,
    title: '健康服务',
  },
  {
    path: '/hospital/static/SeriousIllnessGreenChannel',
    name: 'SeriousIllnessGreenChannel',
    component: () => import(/* webpackPrefetchPlaceHolder */ './SeriousIllnessGreenChannel'),
    auth: true,
    exact: true,
    title: '健康服务',
  },
];
export default route;
